import { Image } from "antd-mobile";
import TreeCard from "components/Tree/TreeCard";
import r, { api } from "modules/Request";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { businessTo } from "utils";
import CollspseListStyle from "./card/CollspseListStyle";
import logoIcon from "./images/logo.png";
import stage_icon1 from "./images/stage_icon1.png";
import stage_icon2 from "./images/stage_icon2.png";
import stage_icon3 from "./images/stage_icon3.png";
import stage_icon4 from "./images/stage_icon4.png";
import stage_icon5 from "./images/stage_icon5.png";
import "./index.scss";
import "./ProductDetail.scss";
export default function CarbonFootprintDetail() {
  document.title = "产品碳足迹分布详情";
  const colorList = [
    { color: "#03BF8A", img: stage_icon1 },
    { color: "#448FFF", img: stage_icon2 },
    { color: "#F0BB35", img: stage_icon3 },
    { color: "#F58D32", img: stage_icon4 },
    { color: "#0CC2BF", img: stage_icon5 },
  ];
  const history = useHistory();
  const [resAll, setResAll] = useState({});
  const [TreeData, setTreeData] = useState([]);
  const { id, type } = r.getQueryString();
  const getPageList = async () => {
    const result = await businessTo(r.get(`${api.GET_FILL_REVIEW}${id}`));
    if (!result) return;
    const zhValues = result.zhProductDetail;
    setResAll(zhValues);
    setTreeData(zhValues?.cumulativeAnalyseVO?.children);
  };
  useEffect(() => {
    r.post(api.DATA_CENTER_VISIT_H5 + id);
    getPageList();
  }, []);
  return (
    <div className="product_detail_box carbon_footprint_detail">
      <div className="carbon_footprint_detail_min_height">
        <p className="carbon_footprint_detail_tip">
          所有碳排放数据均采用单位：<span>kg CO₂e</span>
        </p>
        {TreeData.map((item, idx) => {
          return (
            <div key={idx} className="mb-8">
              <CollspseListStyle>
                <div className="">
                  <h3
                    className="collspse_title collspse_detail_title"
                    // style={{ color: colorList[idx].color }}
                  >
                    <img
                      className="img_list_style"
                      alt=""
                      src={item?.iconUrl}
                    />
                    {item?.name}
                  </h3>
                  <div className="collspse_detail_title_value_box">
                    <p>
                      碳排放：
                      <span
                        className="collspse_detail_title_value"
                        // style={{ color: colorList[idx].color }}
                      >
                        {item?.summaryValueInt?.toFixed(2)}
                      </span>
                    </p>
                    <p className="ml-53r">
                      占比：
                      <span
                        className="collspse_detail_title_value "
                        // style={{ color: colorList[idx].color }}
                      >
                        {item?.proportion}%
                      </span>
                    </p>
                  </div>
                </div>
                <div className="carbon_footprint_detail_card_box">
                  {item?.children.length > 0 && <TreeCard data={item} />}
                </div>
              </CollspseListStyle>
            </div>
          );
        })}
      </div>
      <div className="data_center_logo">
        <Image src={logoIcon} />
      </div>
    </div>
  );
}
